'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Response = exports.Request = exports.Headers = exports.Body = exports.default = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _body = require('./body');

var _body2 = _interopRequireDefault(_body);

var _headers = require('./headers');

var _headers2 = _interopRequireDefault(_headers);

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

var _response = require('./response');

var _response2 = _interopRequireDefault(_response);

var _util = require('./util');

var _node = require('./http/node');

var _node2 = _interopRequireDefault(_node);

var _browser = require('./http/browser');

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 @module fetch
 */

var fetch = function fetch(input, init) {

  var request = new _request2.default(input, init);
  var http = (0, _util.isNode)() ? _node2.default : _browser2.default;

  return http(request);
};

exports.default = fetch;
exports.Body = _body2.default;
exports.Headers = _headers2.default;
exports.Request = _request2.default;
exports.Response = _response2.default;